import React, { FC } from 'react';
import { Customer } from '@models';
import { SubTitle } from '@components';
import { Chip, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { useGetFirebaseProvidersQuery } from '@services';
import { Box } from '@mui/system';
import { providerInfo } from '@constants';

type Props = {
  selectedCustomer: Customer;
};

const FirebaseProviders: FC<Props> = ({ selectedCustomer }) => {
  const { data: firebaseProviders, isLoading } = useGetFirebaseProvidersQuery({ email: selectedCustomer.email });

  const providerData = firebaseProviders?.providerData;
  const providers = providerData?.map((provider) => {
    return {
      providerName: providerInfo.find((name) => name.providerId === provider.providerId)?.providerName,
      providerImage: providerInfo.find((image) => image.providerId === provider.providerId)?.providerImageUrl,
      providerEmail: provider.email,
    };
  });

  if (isLoading)
    return (
      <Box display="flex" alignItems="center" justifyContent="center" height="25vh">
        <Typography>Querying...</Typography>
      </Box>
    );

  return (
    <React.Fragment>
      <SubTitle title="Firebase Authentication Providers" />
      <Paper sx={{ backgroundColor: '#F9F9F7', padding: 5 }}>
        {providers?.length ? (
          providers?.map((provider) => {
            return (
              <Grid container direction="row" alignItems="center" justifyContent="center" sx={{ marginBottom: 4 }}>
                <Grid item xs={3} md={1}>
                  <img src={provider.providerImage} width={50} height={50} alt="provider" data-testid="fbase-provider-img" />
                </Grid>
                <Grid item xs={3}>
                  <Typography data-testid="fbase-provider-name-text">{provider.providerName}</Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography data-testid="fbase-provider-email-text">{provider.providerEmail}</Typography>
                </Grid>
                {/* <Grid item xs={3}>
                    <Button variant="outlined">Unlink</Button>
                  </Grid> */}
              </Grid>
            );
          })
        ) : (
          <Box display="flex" alignItems="center" justifyContent="center">
            <Typography variant="h5">No Linked Providers</Typography>
          </Box>
        )}
      </Paper>

      {/* firebase details */}
      <Paper sx={{ backgroundColor: '#fcf7ff', padding: 5 }}>
        {firebaseProviders ? (
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow sx={{ alignItems: 'center' }}>
                  <TableCell sx={{ border: 1, textAlign: 'center' }}>
                    <b>Firebase UID</b>
                  </TableCell>
                  <TableCell sx={{ border: 1, textAlign: 'center' }}>
                    <b>Created On</b>
                  </TableCell>
                  {firebaseProviders.metadata.lastSignInTime ? (
                    <TableCell sx={{ border: 1, textAlign: 'center' }}>
                      <b>Last Sign In</b>
                    </TableCell>
                  ) : (
                    <TableCell sx={{ border: 1, textAlign: 'center' }}>
                      <b>Status</b>
                    </TableCell>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell sx={{ border: 1, textAlign: 'center' }}>{firebaseProviders.uid}</TableCell>
                  <TableCell sx={{ border: 1, textAlign: 'center' }}>
                    {new Date(firebaseProviders.metadata.creationTime).toDateString()}
                  </TableCell>
                  {firebaseProviders.metadata.lastSignInTime ? (
                    <TableCell sx={{ border: 1, textAlign: 'center' }}>
                      {new Date(firebaseProviders.metadata.lastSignInTime).toDateString()}
                    </TableCell>
                  ) : (
                    <TableCell sx={{ border: 1, textAlign: 'center' }}>
                      <Chip data-testid="customer-inactive" color={'error'} label={'Inactive'} />
                    </TableCell>
                  )}
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Box display="flex" alignItems="center" justifyContent="center">
            <Typography variant="h5">No Firebase Record Found</Typography>
          </Box>
        )}
      </Paper>
    </React.Fragment>
  );
};

export default FirebaseProviders;
